// extracted by mini-css-extract-plugin
export default {"container":"style_container__zv6F7","feedback_container":"style_feedback_container__zRogf","arrow":"style_arrow__D3VIv"};